export default "__VITE_ASSET__Dnt8j1TD__"